import api from "utils/api";

const LESSON_REQUESTS_PATH = "/buccl_lessons/api/v1/lesson-requests";
const INSTRUCTOR_LESSON_REQUESTS_PATH = "/buccl_lessons/api/v1/instructor/lesson-requests";

const unwrapData = (response) => response.data;

export const createLessonRequest = async (payload) => {
    const response = await api.post(`${LESSON_REQUESTS_PATH}/`, payload);
    return unwrapData(response);
};

export const fetchLessonRequestOptions = async () => {
    const response = await api.get(`${LESSON_REQUESTS_PATH}/options/`);
    return unwrapData(response);
};

export const fetchAvailableLessonRequestBrands = async ({ locationId, sportId }) => {
    const response = await api.get(`${LESSON_REQUESTS_PATH}/available-brands/`, {
        params: { location_id: locationId, sport_id: sportId },
    });
    return unwrapData(response);
};

export const fetchMyLessonRequests = async (status = "") => {
    const params = status && status !== "ALL" ? { status } : undefined;
    const response = await api.get(`${LESSON_REQUESTS_PATH}/my/`, params ? { params } : undefined);
    return unwrapData(response);
};

export const fetchLessonRequest = async (id) => {
    const response = await api.get(`${LESSON_REQUESTS_PATH}/${id}/`);
    return unwrapData(response);
};

export const updateLessonRequest = async (id, payload) => {
    const response = await api.patch(`${LESSON_REQUESTS_PATH}/${id}/`, payload);
    return unwrapData(response);
};

export const cancelLessonRequest = async (id) => {
    const response = await api.post(`${LESSON_REQUESTS_PATH}/${id}/cancel/`);
    return unwrapData(response);
};

// 강사 수신함: 본인에게 매칭된 수업 요청 목록
export const fetchInstructorLessonRequests = async (status = "") => {
    const params = status && status !== "ALL" ? { status } : undefined;
    const response = params
        ? await api.get(`${INSTRUCTOR_LESSON_REQUESTS_PATH}/`, { params })
        : await api.get(`${INSTRUCTOR_LESSON_REQUESTS_PATH}/`);
    return unwrapData(response);
};

export const fetchInstructorLessonRequest = async (id) => {
    const response = await api.get(`${INSTRUCTOR_LESSON_REQUESTS_PATH}/${id}/`);
    return unwrapData(response);
};

// 수락 payload: start_time, end_time, capacity, message
export const acceptLessonRequest = async (id, payload) => {
    const response = await api.post(`${INSTRUCTOR_LESSON_REQUESTS_PATH}/${id}/accept/`, payload);
    return unwrapData(response);
};

// 거절 payload: reject_reason
export const rejectLessonRequest = async (id, payload) => {
    const response = await api.post(`${INSTRUCTOR_LESSON_REQUESTS_PATH}/${id}/reject/`, payload);
    return unwrapData(response);
};

export const getLessonRequestErrorMessage = (error) => {
    const data = error?.response?.data;
    if (data?.message) return data.message;
    if (data?.detail) return data.detail;
    if (data && typeof data === "object") {
        const firstValue = Object.values(data)[0];
        if (Array.isArray(firstValue)) return firstValue[0];
        if (typeof firstValue === "string") return firstValue;
    }
    return error?.message || "요청을 처리하지 못했어요.";
};
